<ng-container *ngIf="reportName; else reports">
  <div class="m-subheader">
    <div class="d-flex align-items-center">
      <div class="mr-auto">
        <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
          <li class="m-nav__item">
            <a [routerLink]="['/reports']" class="m-nav__link">
              <i class="m-nav__link-icon la la-home"></i>
              <span class="m-nav__link-text">{{ 'report-base.reports' | transloco }}</span>
            </a>
          </li>
        </ul>
        <h3 class="m-subheader__title">
          {{ 'reports.' + reportName | transloco }}
        </h3>
      </div>
      <div>
      </div>
    </div>
  </div>

  <router-outlet></router-outlet>
</ng-container>

<ng-template #reports>
  <div class="m-subheader">
    <div class="d-flex align-items-center">
      <div class="mr-auto">
        <h3 class="m-subheader__title">
          {{ 'report-base.reports' | transloco }}
        </h3>
      </div>
      <div>
      </div>
    </div>
  </div>

  <div class="m-content">
    <div class="row">
      <div class="col-sm-12">
        <div class="m-portlet m-portlet--full-height">
          <div class="m-portlet__body">
            <a [routerLink]="['/reports/money']">{{ 'reports.money' | transloco }}</a><br/>
            <a [routerLink]="['/reports/money-flow']">{{ 'reports.money-flow' | transloco }}</a><br/>
            <a [routerLink]="['/reports/revenue']">{{ 'reports.revenue' | transloco }}</a><br/>
            <a [routerLink]="['/reports/revenue-by-product']">{{ 'reports.revenue-by-product' | transloco }}</a><br/>
            <a [routerLink]="['/reports/shipment-received']">{{ 'reports.shipment-received' | transloco }}</a><br/>
            <a [routerLink]="['/reports/shipment-refunded']">{{ 'reports.shipment-refunded' | transloco }}</a><br/>
            <a [routerLink]="['/reports/sale']">{{ 'reports.sale' | transloco }}</a><br/>
            <a [routerLink]="['/reports/refund']">{{ 'reports.refund' | transloco }}</a><br/>
            <a [routerLink]="['/reports/product-flow']">{{ 'reports.product-flow' | transloco }}</a><br/>
            <a [routerLink]="['/reports/under-salary']">{{ 'reports.under-salary' | transloco }}</a><br/>
            <a [routerLink]="['/reports/order-status']">{{ 'reports.order-status' | transloco }}</a><br/>
            <a [routerLink]="['/reports/storage-invoice']">{{ 'reports.storage-invoice' | transloco }}</a><br/>
            <a [routerLink]="['/reports/realized-products']">{{ 'reports.realized-products' | transloco }}</a><br/>
            <a [routerLink]="['/reports/storage']">{{ 'reports.storage' | transloco }}</a><br/>
            <a [routerLink]="['/reports/product-release']">{{ 'reports.product-release' | transloco }}</a><br/>
            <a [routerLink]="['/reports/feedback-rating']">{{ 'reports.feedback-rating' | transloco }}</a><br/>
            <a [routerLink]="['/reports/user-received-order']">{{ 'reports.user-received-order' | transloco }}</a><br/>
            <a [routerLink]="['/reports/product-discard']">{{ 'reports.product-discard' | transloco }}</a><br/>
            <a [routerLink]="['/reports/storage-flow']">{{ 'reports.storage-flow' | transloco }}</a><br/>
            <a [routerLink]="['/reports/supplier-payment']">{{ 'reports.supplier-payment' | transloco }}</a><br/>
            <a [routerLink]="['/reports/delivery-heat-count-map']">{{ 'reports.delivery-heat-count-map' | transloco }}</a><br/>
            <a [routerLink]="['/reports/inv-mgmt']">{{ 'reports.inv-mgmt' | transloco }}</a><br/>
            <a [routerLink]="['/reports/profit-loss-statement']">{{ 'reports.profit-loss-statement' | transloco }}</a><br/>
            <a [routerLink]="['/reports/receivables-payables']">{{ 'reports.receivables-payables' | transloco }}</a><br/>
            <a [routerLink]="['/reports/cash-flow']">{{ 'reports.cash-flow' | transloco }}</a><br/>
            <a [routerLink]="['/reports/payment-schedule']">{{ 'reports.payment-schedule' | transloco }}</a><br/>
            <a [routerLink]="['/reports/cancel-orders']">{{ 'reports.cancel-orders' | transloco }}</a><br/>
            <a [routerLink]="['/reports/manager_sales_report']">{{ 'reports.manager_sales_report' | transloco }}</a><br/>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
